import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMixinLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 20,
	viewBox: "0 0 25 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_1507_1487)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M24.6428 0.5C24.8364 0.5 24.994 0.652539 24.9998 0.842911L25 0.853935V19.146C25 19.1985 24.9882 19.2504 24.9655 19.2979C24.8824 19.471 24.6761 19.5466 24.5001 19.4704L24.4896 19.4656L19.9104 17.3093C19.697 17.2089 19.5594 16.998 19.5538 16.7648L19.5536 16.7499V2.93832C19.5536 2.69113 19.7018 2.46812 19.9298 2.37012L19.9433 2.3645L24.5084 0.52604C24.5511 0.508843 24.5968 0.5 24.6428 0.5ZM0.357143 0.5C0.403237 0.5 0.448896 0.508843 0.491598 0.52604L5.05672 2.3645C5.29231 2.45938 5.44644 2.68629 5.44644 2.93832V16.7499C5.44644 16.989 5.30756 17.2067 5.08964 17.3093L0.510421 19.4656C0.332263 19.5495 0.119216 19.4744 0.0345635 19.2979C0.0118069 19.2504 0 19.1985 0 19.146V0.853935C0 0.658462 0.159898 0.5 0.357143 0.5ZM12.9018 4.49548L17.1243 6.91142C17.3729 7.05368 17.5261 7.31659 17.5261 7.60111V12.433C17.5261 12.7175 17.3729 12.9804 17.1243 13.1227L12.9018 15.5386C12.6532 15.6808 12.3468 15.6808 12.0982 15.5386L7.87573 13.1227C7.6271 12.9804 7.47395 12.7175 7.47395 12.433V7.60111C7.47395 7.31659 7.6271 7.05368 7.87573 6.91142L12.0982 4.49548C12.3468 4.35322 12.6532 4.35322 12.9018 4.49548Z",
			fill: "url(#paint0_linear_1507_1487)"
		})
	}), /* @__PURE__ */ _jsxs("defs", { children: [/* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_1507_1487",
		x1: 12.5,
		y1: .5,
		x2: 12.5,
		y2: 19.5,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#44BCFF" }), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#3485FF"
		})]
	}), /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_1507_1487",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 25,
			height: 19,
			fill: "white",
			transform: "translate(0 0.5)"
		})
	})] })]
});
export default SvgMixinLogo;
